<template>
<div>
<div class="container">
        <p class="title">完善个人信息</p>
        <p class="little_title" > 请填写您的工服尺寸和身高</p>
        <div class="choose">
          <div @click="showM">
              <span>{{sizeM.value}}</span>
              <img src="../../assets/triangle_open.png" />
          </div>
          <div @click="showT">
              <span>{{sizeT.value}}</span>
              <img src="../../assets/triangle_open.png" />
          </div>
        </div>
    <input placeholder="填写身高 (如175)" v-model="height" type="text" @input="watchVal($event)"/>
        <!-- <button @click="submit">提交</button> -->
          <awesome-picker
            ref="picker"
            :data="picker.data"
            :textTitle="picker.textTitleM"
            :textConfirm="picker.textConfirm"
            :textCancel="picker.textCancel"
            @confirm="handlePickerConfirmM">
          </awesome-picker>
          <awesome-picker
            ref="picker1"
            :data="picker.data"
            :textTitle="picker.textTitleT"
            :textConfirm="picker.textConfirm"
            :textCancel="picker.textCancel"
            @confirm="handlePickerConfirmT">
          </awesome-picker>
    </div>
  <button @click="submit">提交</button>
</div>
</template>
<script>
import { getSignUpInfo, updateTshirt, checkStatus } from '../../utils/actions'
export default {
  data () {
    return {
      bagColor: 'linear-gradient(269deg, #3B414D 0%, #262A32 100%)',
      height: '',
      sizeM: {
        key: '',
        value: '马甲尺寸'
      },
      sizeT: {
        key: '',
        value: 'T恤尺寸'
      },
      picker: {
        textTitleM: '编辑马甲尺寸',
        textTitleT: '编辑T恤尺寸',
        textConfirm: '确定',
        textCancel: '取消',
        data: []
      }
    }
  },
  created () {
    this.getSignUpInfo()
  },
  methods: {
    watchVal (e) {
      let val = e.target.value
      this.height = val.substring(0, 3)
    },
    showM () {
      this.$refs.picker.show()
    },
    showT () {
      this.$refs.picker1.show()
    },
    setData (arr) {
      let {entries} = Object
      let data = []
      for (let [key, value] of entries(arr)) {
        data.push({key, value})
      }
      return data
    },
    async getSignUpInfo () {
      let _this = this
      let data = await getSignUpInfo({
        id: _this.$store.state.id,
        open_id: _this.$store.state.openid
      })
      if (data && data.data) {
        let obj = data.data
        if (obj.height !== '0' || obj.size !== '' || obj.size_tshirt !== '') {
          let sizeM = obj.size
          let sizeT = obj.size_tshirt
          console.log(data.data.clothing_size_list[sizeM])
          _this.sizeM.key = sizeM
          _this.sizeT.key = obj.size_tshirt
          _this.sizeM.value = data.data.clothing_size_list[sizeM]
          _this.sizeT.value = data.data.clothing_size_list[sizeT]
          _this.height = obj.height
        }
        let objSize = _this.setData(data.data.clothing_size_list)
        _this.picker.data = objSize
      }
    },
    handlePickerConfirmM (item) {
      this.sizeM = this.picker.data[item[0].index]
    },
    handlePickerConfirmT (item) {
      this.sizeT = this.picker.data[item[0].index]
    },
    async submit () {
      let _this = this
      if (!_this.sizeT.key || !_this.sizeM.key || !_this.height) {
        alert('请完善尺寸信息！')
        return
      }
      if (_this.height.length !== 3) {
        alert('格式只能为3位数')
        return
      }
      let status = await checkStatus({
        open_id: _this.$store.state.openid
      })
      if (!status) return
      switch (status.data.status) { // 待完善
        case '12': // 面试通过
        case '13': // 路考未预约
        case '16': // 路考不通过
          // 预约路考页面 6
          this.$router.push({name: 'appointedRoadTest', params: {status: status.data.status}})
          break
        case '14': // 路考已预约-报名完成
        case '15': // 路考进行中
        case '17': // 路考通过
        case '18': // 成功签约
        case '19': // 已领装备
          this.$router.push({name: 'passStatus', params: {status: status.data.status}})
          break
        default:
          break
      }
      let data = await updateTshirt({
        size_tshirt: _this.sizeT.key,
        id: _this.$store.state.id,
        open_id: _this.$store.state.openid,
        height: _this.height,
        size: _this.sizeM.key
      })
      if (data || data.data) {
        this.$router.back()
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.container{
    width: 80%;
    margin-left: 10%;
    .title{
        font-size: .4rem;
        color: #19191A;
        font-weight: bold;
        margin-top: .8rem;
    }
    .little_title{
        font-size: .24rem;
        color: #19191A;
          margin-bottom: .08rem;
    }
    .choose{
        font-size: .28rem;
        width: 100%;
        border-bottom: 1px solid #E8E9EB;
         height: .98rem;
        line-height: .98rem;
        padding: 0
    }
    input{
        height: .98rem;
        line-height: .98rem;
        font-size: .28rem;
        width: 100%;
        border:none;
        background: #FCFDFF;
        border-bottom: 1px solid #E8E9EB;
        padding: 0;
        border-radius: 0;
    }
}
.choose{
  div{
    width: 40%;
    display: inline-block;
    float: left;
    span{
      display: inline-block;
      width: 80%;
    }
  }
  img{
    width: .12rem;
    height: auto;
  }
}
.choose div:last-child{
  text-align: right;
  margin-left: 20%;
  span{
    text-align: left;
  }
}
.choose:after{
  content: '';
  clear: both;
  display: block;
}
 button{
        height: .92rem;
        line-height: .92rem;
        background-image: linear-gradient(269deg, #3B414D 0%, #262A32 100%);
        color: #fff;
        border-radius: .04rem;
        margin-left: 7%;
        width: 86%;
        font-size: .3rem;
        vertical-align: bottom;
        margin-top: .8rem;
        border:none;
        box-sizing: border-box;
    }
</style>



// WEBPACK FOOTER //
// src/pages/edit-coveralls/index.vue